<div class="help-view__intro-blurb" [ngClass]="useRailLayout ? 'rail-layout-grid' : 'layout-grid'">
  <p>Pick one of the categories below to quickly jump to a section of help articles or scroll down to browse all articles.</p>

  <ul class="help-view__navigation" [ngClass]="useRailLayout ? 'rail-layout-grid' : 'layout-grid'">
    @for (section of helpArticles | keyvalue; track section) {
      <li>
        <a (click)="onClick_scrollToAnchor(section.key); $event.preventDefault()" [href]="'#' + section.key">{{section.key | titleCasePipe:true:titleCaseOverrides}}</a>
        @if (section.value.length > 1) {
          <ul>
            @for (articleGroup of section.value; track articleGroup) {
              @if (articleGroup.group) {
                <li>
                  <a (click)="onClick_scrollToAnchor(groupAnchor(section.key, articleGroup.group)); $event.preventDefault()" [href]="'#' + groupAnchor(section.key, articleGroup.group)">{{articleGroup.group}}</a>
                </li>
              }
            }
          </ul>
        }
      </li>
    }
  </ul>
</div>

@for (section of helpArticles | keyvalue; track section) {
  <section class="help-view__section" [ngClass]="useRailLayout ? 'rail-layout-grid' : 'layout-grid'" [id]="section.key">
    <!-- The copy-link button is a SIBLING of the heading, not a child: a descendant control's
    accessible name folds into the heading's, and this heading is what labels the article lists. -->
    <div class="help-view__title-row">
      <h2 class="help-view__section-title" [id]="'aria_help_section_'+section.key">
        {{section.key | titleCasePipe:true:titleCaseOverrides}}
      </h2>
      <button type="button" matIconButton class="help-view__link-button"
        [attr.aria-label]="'Copy link to ' + (section.key | titleCasePipe:true:titleCaseOverrides) + ' section'"
        (click)="onClick_copyBookmarkLink(section.key)">
        <mat-icon class="help-view__link-icon">link</mat-icon>
      </button>
    </div>
    @for (articleGroup of section.value; track articleGroup) {
      @if (articleGroup.group) {
        <!-- The h3 keeps groupAnchor() as its own id: unlike the section heading, this id IS the
        deep-link scroll target, so it must not be namespaced. -->
        <div class="help-view__title-row">
          <h3 class="group-subheader help-view__section-title" [id]="groupAnchor(section.key, articleGroup.group)">
            {{articleGroup.group}}
          </h3>
          <button type="button" matIconButton class="help-view__link-button"
            [attr.aria-label]="'Copy link to ' + articleGroup.group + ' section'"
            (click)="onClick_copyBookmarkLink(groupAnchor(section.key, articleGroup.group))">
            <mat-icon class="help-view__link-icon">link</mat-icon>
          </button>
        </div>
      }
      <ul class="help-view__articles layout-grid--row-gap"
          [ngClass]="useRailLayout ? 'rail-layout-grid' : 'layout-grid'"
          role="list" [attr.aria-labelledby]="'aria_help_section_'+section.key">
        @for (article of articleGroup.articles; track article) {
          <li class="help-view__article">
            <mat-card appearance="outlined" [id]="article.bookmark">
              <mat-card-title>{{article.title}}</mat-card-title>
              <mat-card-content class="gcr-help" [innerHtml]="article.trustedBody"></mat-card-content>
            </mat-card>
          </li>
        }
      </ul>
    }
  </section>
}
@if (showScrollToTop) {
  <button type="button" matFab aria-label="Scroll to top" class="help-view__scroll-to-top" (click)="onClick_scrollToTop()">
    <mat-icon>expand_less</mat-icon>
  </button>
}
